"use strict";

var _taggedTemplateLiteral = require("/app/react/marvin/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject, _templateObject2;

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledcomponents = require('styled-components');

var t = function t(e, a) {
  var n = e + "Max";
  return _styledcomponents.css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n        @media (max-width: ", ") {\n            ", "\n        }\n    "])), function (_ref) {
    var i = _ref.theme;
    return i.breakpoints[n];
  }, a);
},
    m = exports.b = t,
    r = exports.c = function (e, a) {
  var n = e + "Min";
  return _styledcomponents.css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n        @media (min-width: ", ") {\n            ", "\n        }\n    "])), function (_ref2) {
    var i = _ref2.theme;
    return i.breakpoints[n];
  }, a);
},
    s = exports.d = r;

exports.a = t;
exports.b = m;
exports.c = r;
exports.d = s;